<template>
  <ul class="praise-list">
    <!-- 已购产品 -->
    <li
      v-for="item in list"
      :key="item.FormId"
      :class="item.FormId == '0' ? 'wg_box' : 'yg_box'"
    >
      <div
        v-if="item.BannerPicture"
        class="img_box no-bg"
        @click.prevent="handelBanner(item)"
      >
        <van-image class="img" :src="api.FileHost + item.BannerPicture" />
        <div v-if="item.FormId == '0' && !item.IsOpenClass" class="zzc">
          <img alt="" src="@/assets/images/suo.png" />
        </div>
        <div v-if="item.FormStatus == '20'" class="ywcbx">已完成</div>
      </div>
      <div v-else class="img_box" @click.prevent="handelBanner(item)">
        <h3 class="title">{{ item.ProductName }}</h3>
        <div class="line"></div>
        <p style="text-align: center">{{ item.ProdDesc }}</p>
        <div v-if="item.FormId == '0' && !item.IsOpenClass" class="zzc">
          <img alt="" src="@/assets/images/suo.png" />
        </div>
        <div v-if="item.FormStatus == '20'" class="ywcbx">已完成</div>
      </div>
      <div class="right_box">
        <a
          href="javascript:;"
          @click.prevent="
            $go('CaseWjsContent', { params: { id: item.ProductId } })
          "
        >
          <h3>
            {{ item.ProductName }}
          </h3>
        </a>
        <p style="text-align: right">
          {{ item.ProdDesc }}
        </p>
        <div
          v-if="
            item.FormId != '0' &&
            (item.FormStatus == '20' || item.FormStatus == '10')
          "
          class="btn"
          @click.prevent="goContent(item)"
        >
          <span style="color: #fff">进入</span>
          <van-icon color="#fff" name="arrow" />
        </div>
        <!-- 公开课-->
        <div
          v-if="item.FormId == '0' && item.IsOpenClass"
          class="btn"
          @click.prevent="CreateOpenClassForm(item)"
        >
          <span style="color: #fff">免费领取</span>
          <van-icon color="#fff" name="arrow" />
        </div>
        <!-- FormStatus = 0 :未开始    item.FormId = 0 ：没购买-->
        <!-- <div
          v-if="item.FormId == '0' && !item.IsOpenClass"
          class="wksbtn"
          @click.prevent="
            $go('CaseWjsContent', { params: { id: item.ProductId } })
          "
        >
          <span style="color: #5d6269">了解更多</span>
          <van-icon color="#5D6269" name="arrow" />
        </div> -->
        <!-- 立即购买 （替换了解更多） -->
        <div
          v-if="item.FormId == '0' && !item.IsOpenClass && isOpen"
          class="btn"
          @click.prevent="createPurOrder(item)"
        >
          <span style="color: #fff">立即购买</span>
          <van-icon color="#fff" name="arrow" />
        </div>
        <!-- 未开通微信支付 -->
        <div
          v-if="item.FormId == '0' && !item.IsOpenClass && !isOpen"
          class="wksbtn"
          @click.prevent="
            $go('CaseWjsContent', { params: { id: item.ProductId } })
          "
        >
          <span style="color: #5d6269">了解更多</span>
          <van-icon color="#5D6269" name="arrow" />
        </div>

        <!-- FormStatus = 0 :未开始    item.FormId = 0 ：没购买-->
        <div
          v-if="item.FormStatus == '0' && item.FormId != '0'"
          class="wksbtn"
          @click.prevent="
            $go('CaseWjsContent', { params: { id: item.ProductId } })
          "
        >
          <span style="color: #5d6269">未开始，了解更多</span>
          <van-icon color="#5D6269" name="arrow" />
        </div>
        <div v-if="item.Duration != 0" class="expire">
          <div v-if="item.TermDay > 0">
            还有
            <span>{{ item.TermDay }}</span>
            天结束
          </div>
          <div v-if="item.TermDay < 0">
            已结束
            <span>{{ Math.abs(item.TermDay) }}天</span>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <van-empty v-if="!list.length" description="暂无数据" image="default" />
</template>
<script>
  import store from '@/store'
  import { Toast } from 'vant'
  import api from '@/api'
  export default {
    components: {},
    props: {
      list: {
        type: Array,
        default() {
          return []
        },
      },
      showFreeClass: {
        type: Function,
        default: null,
      },
    },
    data() {
      return {
        api,
        isOpen: false,
      }
    },
    watch: {
      list: {
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            let tit = document.getElementsByClassName('title')

            for (let i = 0; i < tit.length; i++) {
              //console.log('tit :>> ', tit[i])
              if (tit[i].scrollWidth > tit[i].clientWidth) {
                //说明超出文字范围
                // do something
                tit[i].className += ' ts' //超出范围 添加 ts 样式类名
              }
            }
          })
        },
        deep: true,
        immediate: true,
      },
    },
    created() {
      this.getOpenPayment()
    },
    methods: {
      async getOpenPayment() {
        const tenant = await store.getters['user/getTenant']
        const url = 'user/WechatSubMerchantIsOpenWechatPayment'
        const params = {
          tenantId: tenant ? tenant.TenantId : 0,
        }
        store
          .dispatch(url, params)
          .then((res) => {
            const { Data, Code } = res
            if (Code === 0) {
              this.isOpen = Data
            }
          })
          .catch((e) => {
            Toast.fail(e.Message || '获取是否开通支付失败')
          })
      },
      // 创建购买订单
      async createPurOrder(item) {
        //先判断是否需要审核
        // let result = await this.isExamine(item)
        // if (result) return

        const toast = Toast.loading({
          message: '创建订单中~',
          duration: 0,
          forbidClick: true,
        })
        const tenant = await store.getters['user/getTenant']
        const H5Url = await store.getters['system/getH5Url']
        const params = {
          productId: item.ProductId,
          tenantId: tenant.TenantId,
        }
        store
          .dispatch('service/CreateFormPurchaseOrder', params)
          .then((data) => {
            const { Data } = data
            const url = `${H5Url}case/#/pay?type=coupon&orderNo=${Data.OrderNo}`
            toast.clear()
            window.location.href = url
          })
          .catch((e) => {
            const { Message } = e
            Toast.fail(Message || '创建订单失败！')
          })
      },
      handelBanner(item) {
        if (item.FormId && item.FormId != '0' && item.FormStatus != '0') {
          this.goContent(item)
        } else {
          this.$go('CaseWjsContent', { params: { id: item.ProductId } })
        }
      },
      goContent(item) {
        this.$router.push({
          name: 'ServiceContent',
          params: {
            id: item.FormId,
          },
        })
      },
      //判断是否需要审核
      isExamine(item) {
        const toast = Toast.loading({
          message: '加载中...',
          duration: 0,
          forbidClick: true,
        })
        const params = {
          productId: item.ProductId,
        }
        let hasExam = false
        return new Promise((resolve, reject) => {
          store
            .dispatch('service/GetProductWorkflow', params)
            .then((data) => {
              toast.clear()
              const { Code, Message, Data } = data
              hasExam = Data && Data.includes('AdvancedApproving')
              if (hasExam) {
                Toast('报名产品前需审核，请联系老师报名')
              }
              resolve(hasExam)
            })
            .catch((e) => {
              Toast(`${e.Message || '获取审核失败！'}`)
              hasExam = false
              resolve(hasExam)
            })
        })
      },

      async CreateOpenClassForm(item) {
        //先判断是否需要审核
        // let result = await this.isExamine(item)
        // if (result) return
        this.showFreeClass(item.ProductId)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .praise-list {
    padding: 12px 20px 0;
    .expire {
      font-size: 14px;
      color: #666;
      margin-top: 6px;
    }
    .yg_box {
      background: #ffffff;
      //border: 1px solid #e8e8e9;
      box-shadow: 0px 0px 10px 0px rgba(232, 232, 233, 0.88);
      border-radius: 9px;
      min-height: 100px;
      margin-bottom: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 10px 15px;
      .img_box {
        width: 150px;
        height: 90px;
        border-radius: 9px;
        overflow: hidden;
        position: relative;
        background-image: url('../../../assets/images/kebj.png');
        background-repeat: no-repeat;
        background-size: cover;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &.no-bg {
          background: none;
        }
        .img {
          width: 100%;
          height: 100%;
        }
        .ywcbx {
          background-color: #b57e48;
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          font-size: 12px;
          border-top-left-radius: 8px;
          border-bottom-right-radius: 8px;
          padding: 2px 4px;
        }
        h3 {
          font-size: 18px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          margin-bottom: 7px;
          width: 130px;
          text-align: center;
          white-space: nowrap;
        }
        h3.ts {
          font-size: 12px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          margin-bottom: 7px;
          width: 130px;
          white-space: pre-wrap;
        }
        .line {
          width: 18px;
          height: 1px;
          background: #ffffff;
        }
        p {
          font-size: 8px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          width: 87%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-top: 7px;
        }
        // img {
        //   width: 100%;
        //   height: 100%;
        // }
        .wjs {
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.5);
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
      .right_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        h3 {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: right;
        }

        p {
          padding: 0;
          margin: 0;
          margin-bottom: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #7d7d7f;
          width: 130px;
          overflow: hidden; //超过其长度之后，自动隐藏其换行的字符
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .wg_box {
      background: #ffffff;
      //border: 1px solid #e8e8e9;
      box-shadow: 0px 0px 10px 0px rgba(232, 232, 233, 0.88);
      border-radius: 9px;
      height: 120px;
      margin-bottom: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      .img_box {
        width: 150px;
        height: 90px;
        border-radius: 9px;
        overflow: hidden;
        position: relative;
        margin: 15px 0;
        background-image: url('../../../assets/images/kebj.png');
        background-repeat: no-repeat;
        background-size: cover;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &.no-bg {
          background: none;
        }
        .img {
          width: 100%;
          height: 100%;
        }
        h3 {
          font-size: 18px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          margin-bottom: 7px;
          width: 130px;
          text-align: center;
          white-space: nowrap;
        }
        h3.ts {
          font-size: 12px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          margin-bottom: 7px;
          width: 130px;
          white-space: pre-wrap;
        }
        .line {
          width: 18px;
          height: 1px;
          background: #ffffff;
        }
        p {
          font-size: 8px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          width: 87%;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-top: 7px;
        }
        .zzc {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba($color: #000000, $alpha: 0.6);
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        .wjs {
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.6);
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
      .right_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        h3 {
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: right;
        }
        p {
          padding: 0;
          margin: 0;
          margin-bottom: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #7d7d7f;
          width: 130px;
          overflow: hidden; //超过其长度之后，自动隐藏其换行的字符
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .btn {
      width: 99px;
      height: 32px;
      background: #b57e48;
      border-radius: 16px;
      font-size: #fff;
      text-align: center;
      line-height: 32px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-left: 12px;
      span {
        padding-right: 5px;
      }
      .wksbtn {
        width: 99px;
        height: 32px;
        background: transparent;
        border-radius: 16px;
        font-size: #fff;
        text-align: center;
        line-height: 32px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        span {
          padding-right: 5px;
        }
      }
    }
  }
</style>
